<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Growing up on the east-side of Vancouver BC in the 60s there was no internet, no computer games; just pinball, and, by the mid-70s, Pacman, so we were to make our own games or play board games, which we did. We also did stupid things when it got boring like dekes where we would run down a crowded street and try not to hit anyone. Jail tag on bikes. As I got older, I started to read about WWII but it got boring so I began reading horror and science fiction.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0667c06e